import React from 'react';
import { generatePath } from 'react-router';
import RoutePath from '@/Routing/RoutePath';
import { useAssessmentsOverviewContext } from '../Contexts/AssessmentsOverviewContext';
import ActiveAssessmentsOverviewList from './ActiveAssessmentsOverviewList';
import ClosedAssessmentsOverviewList from './ClosedAssessmentsOverviewList';
import useCompanyId from '@/Hooks/UseCompanyId';
import useClientIdPathParam from '@/Hooks/UseClientIdPathParam';

function AssessmentsOverviewTabs(): React.JSX.Element {
    const { currentTab } = useAssessmentsOverviewContext();
    const companyId = useCompanyId();
    const clientId = useClientIdPathParam();

    const open = generatePath(RoutePath.AssessmentsActive, { companyId, clientId });
    const closed = generatePath(RoutePath.AssessmentsClosed, { companyId, clientId });

    return (
        <>
            {currentTab === open && <ActiveAssessmentsOverviewList />}
            {currentTab === closed && <ClosedAssessmentsOverviewList />}
        </>
    );
}

export default AssessmentsOverviewTabs;
